import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const sections = [
  {
    title: '1. 個人情報の収集について',
    content: `当サービス「Dr.Catch」（以下「本サービス」）では、カウンセリングのご予約・お問い合わせの際に、お名前、メールアドレス、その他必要な情報をご提供いただく場合があります。これらの情報は、サービス提供に必要な範囲でのみ収集いたします。`,
  },
  {
    title: '2. 個人情報の利用目的',
    content: `収集した個人情報は、以下の目的のために利用いたします。\n・カウンセリングセッションの予約・管理\n・お問い合わせへの回答\n・サービスに関する重要なご連絡\n・サービス品質の向上のための分析（個人を特定しない形で行います）`,
  },
  {
    title: '3. 個人情報の第三者提供',
    content: `当サービスは、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。\n・お客様ご本人の同意がある場合\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要がある場合`,
  },
  {
    title: '4. 個人情報の管理',
    content: `当サービスは、お客様の個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、適切なセキュリティ対策を実施いたします。`,
  },
  {
    title: '5. Cookieの使用について',
    content: `本サービスでは、サービスの利便性向上のためCookieを使用する場合があります。ブラウザの設定によりCookieを無効にすることも可能ですが、一部機能がご利用いただけなくなる場合があります。`,
  },
  {
    title: '6. 個人情報の開示・訂正・削除',
    content: `お客様は、当サービスが保有するご自身の個人情報について、開示・訂正・削除を請求することができます。ご希望の場合は、下記お問い合わせ先までご連絡ください。`,
  },
  {
    title: '7. プライバシーポリシーの変更',
    content: `当サービスは、必要に応じて本プライバシーポリシーを変更することがあります。変更後のポリシーは、本ページに掲載した時点から効力を生じるものとします。`,
  },
  {
    title: '8. お問い合わせ',
    content: `個人情報の取り扱いに関するお問い合わせは、カウンセリング予約ページのお問い合わせフォームよりご連絡ください。`,
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F5] to-white">
      <Navigation />

      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-14">
            <p className="text-sm tracking-[0.3em] text-[#C9A0A0] uppercase mb-3">Privacy Policy</p>
            <h1 className="text-3xl md:text-4xl font-serif mb-4 text-[#2C2C2C]">プライバシーポリシー</h1>
            <div className="w-24 h-px bg-[#D4A5A5] mx-auto mb-4"></div>
            <p className="text-sm text-[#888888]">最終更新日：2024年1月1日</p>
          </div>

          {/* Intro */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#F5E8E4] mb-8">
            <p className="text-base leading-loose text-[#4A4A4A]">
              Dr.Catch（以下「当サービス」）は、お客様の個人情報の保護を重要な責務と考え、以下のプライバシーポリシーに従って個人情報を適切に取り扱います。本サービスをご利用いただく前に、必ずお読みください。
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-6">
            {sections.map((section) => (
              <div
                key={section.title}
                className="bg-white rounded-2xl p-8 shadow-sm border border-[#F5E8E4]"
              >
                <h2 className="text-base font-semibold text-[#2C2C2C] mb-4 flex items-center gap-3">
                  <span className="w-1.5 h-5 bg-[#D4A5A5] rounded-full inline-block flex-shrink-0"></span>
                  {section.title}
                </h2>
                <p className="text-sm leading-loose text-[#4A4A4A] whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            ))}
          </div>

          {/* Back link */}
          <div className="text-center mt-14">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#C9A0A0] hover:text-[#B88B8B] transition-colors text-sm cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              トップページに戻る
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
